export default function ClarksvilleFinalCTA() {
  return (
    <section id="contact" className="relative bg-[#1A365D] py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=American%20flag%20waving%20in%20sunset%20golden%20hour%20against%20a%20warm%20evening%20sky%20with%20military%20silhouettes%20in%20the%20background%2C%20patriotic%20editorial%20photography%2C%20deep%20warm%20orange%20and%20amber%20tones%2C%20cinematic%20quality&width=1600&height=600&seq=clarksville-cta-bg&orientation=landscape"
          alt="Fort Campbell"
          className="w-full h-full object-cover opacity-10"
        />
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-[#F6C344]/20 text-[#F6C344] text-xs font-bold uppercase tracking-wider px-4 py-2 rounded-full mb-6">
          <i className="ri-shield-star-line"></i>
          Fort Campbell Military Specialists
        </div>

        <h2 className="font-serif text-3xl md:text-5xl font-bold text-white leading-tight mb-6">
          Don't Let Your Passport
          <span className="text-[#F6C344]"> Stop Your Mission</span>
        </h2>

        <p className="text-white/70 text-lg leading-relaxed mb-10 max-w-2xl mx-auto">
          Whether it's a deployment order, a family PCS, or an APSU study abroad deadline — we have your passport ready when you need it. Clarksville's fastest passport processing service, trusted by Fort Campbell families.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <a
            href="tel:+18001234567"
            className="inline-flex items-center gap-2 bg-[#F6C344] text-[#1A365D] font-bold px-10 py-4 rounded-lg hover:bg-[#e5b33f] transition-all text-lg whitespace-nowrap"
          >
            <i className="ri-phone-line"></i>
            Call for Emergency Service
          </a>
          <a
            href="#how-it-works"
            className="inline-flex items-center gap-2 border-2 border-white/30 text-white font-semibold px-8 py-4 rounded-lg hover:border-white/60 hover:bg-white/10 transition-all whitespace-nowrap"
          >
            <i className="ri-arrow-up-line"></i>
            Back to Top
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
          {[
            { label: "Emergency", value: "24hr" },
            { label: "Military Families", value: "1,200+" },
            { label: "Miles to Nashville", value: "50" },
            { label: "Satisfaction", value: "100%" },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <div className="font-serif text-3xl font-bold text-[#F6C344] mb-1">{stat.value}</div>
              <div className="text-white/60 text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}